export const FETCH_AD = 'FETCH_AD';
export const PUSH_AD = 'PUSH_AD';
export const REMOVE_AD = 'REMOVE_AD';
export const UPDATE_AD = 'UPDATE_AD';
export const UPDATE_MODE = 'UPDATE_MODE';
export const UPDATE_ACTIVE_ID = 'UPDATE_ACTIVE_ID';

export function fetchAds(data){
  return (dispatch) => {
    dispatch({
      type: FETCH_AD,
      payload:data
    });
  }
}

export function pushAds(data){
  return (dispatch) => {
    dispatch({
      type: PUSH_AD,
      payload:data
    });
  }
}

export function removeAds(data){
  return (dispatch) => {
    dispatch({
      type: REMOVE_AD,
      payload:data
    });
  }
}

export function updateAd(data){
  return (dispatch) => {
    dispatch({
      type: UPDATE_AD,
      payload:data
    });
  }
}

export function updateMode(data){
  return (dispatch) => {
    dispatch({
      type: UPDATE_MODE,
      payload:data
    });
  }
}

export function updateActiveAd(mode, id){
  return (dispatch) => {
    dispatch({
      type: UPDATE_ACTIVE_ID,
      mode,
      id
    });
  }
}
